// Blog highlights - mobile-only autoplay slider.
// Desktop stays a static 3-up grid; below the breakpoint it becomes a
// Flickity slider. Uses the Flickity + jQuery already loaded globally
// in theme.liquid.
(function () {
  var BREAKPOINT = 768;

  function initSlider(el) {
    if (!el || el.classList.contains('flickity-enabled')) return;
    if (typeof jQuery === 'undefined' || typeof Flickity === 'undefined') return;

    jQuery(el).flickity({
      cellAlign: 'center',
      contain: true,
      wrapAround: true,
      autoPlay: 3500,
      pauseAutoPlayOnHover: true,
      prevNextButtons: false,
      pageDots: false,
      draggable: true
    });

    var flkty = Flickity.data(el);
    if (!flkty) return;

    // Flickity can leave autoPlay stalled after the slider is dragged/hovered
    // instead of resuming on its own - force it back on once the interaction ends.
    flkty.on('pointerUp', function () {
      flkty.playPlayer();
    });
    el.addEventListener('mouseleave', function () {
      flkty.playPlayer();
    });
  }

  function destroySlider(el) {
    if (!el || !el.classList.contains('flickity-enabled')) return;
    if (typeof jQuery === 'undefined') return;
    jQuery(el).flickity('destroy');
  }

  function sync(scope) {
    var root = scope || document;
    var sliders = root.querySelectorAll ? root.querySelectorAll('[data-bh-slider]') : [];
    var isMobile = window.matchMedia('(max-width: ' + BREAKPOINT + 'px)').matches;

    for (var i = 0; i < sliders.length; i++) {
      if (isMobile) {
        initSlider(sliders[i]);
      } else {
        destroySlider(sliders[i]);
      }
    }
  }

  function debounce(fn, wait) {
    var timer;
    return function () {
      var ctx = this, args = arguments;
      clearTimeout(timer);
      timer = setTimeout(function () {
        fn.apply(ctx, args);
      }, wait);
    };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      sync(document);
    });
  } else {
    sync(document);
  }

  window.addEventListener('resize', debounce(function () {
    sync(document);
  }, 200));

  // Re-init when a merchant adds/edits this section in the theme editor.
  document.addEventListener('shopify:section:load', function (event) {
    sync(event.target);
  });
})();
